import request from '@/utils/request'

// 概览简介
export function overviewInfo(data) {
  return request({
    method: 'get',
    url: 'Overview/overviewInfo',
    params: data
  })
}
// 欢迎词
export function welcome(data) {
  return request({
    method: 'get',
    url: 'Welcome/welcomeGetlist',
    params: data
  })
}
// 概览详情
export function overviewDetails(data){
  return request({
    method: 'get',
    url: 'Overview/overviewDetails',
    params: data
  })
}
// 温馨校园
export function CampusGetLists(data){
  return request({
    method: 'get',
    url: 'Campus/getList',
    params: data
  })
}
// 文章分类
export function Article_type(data){
  return request({
    method: 'get',
    url: 'Article_type/getList',
    params: data
  })
}
// 文章列表 Article/getList
export function ArticlegetList(data){
  return request({
    method: 'get',
    url: 'Article/getList',
    params: data
  })
}
// 文章详情
export function articleDetails(data){
  return request({
    method: 'get',
    url: 'Article/articleDetails',
    params: data
  })
}
// 获取学院列表 University/getList
export function UniversityList(data){
  return request({
    method: 'get',
    url: 'University/getList',
    params: data
  })
}
// 获取生涯规划 Career/getList
export function CareerList(data){
  return request({
    method: 'get',
    url: 'Career/getList',
    params: data
  })
}
// 家长志愿者 Volunteer/getList
export function VolunteerList(data){
  return request({
    method: 'get',
    url: 'Volunteer/getList',
    params: data
  })
}
// 共育篇 Volunteer/coeducationConfig
export function coeducationConfig(data){
  return request({
    method: 'get',
    url: 'Volunteer/coeducationConfig',
    params: data
  })
}
// 家长课堂 Volunteer/parentsClassroom
export function parentsClassroom(data){
  return request({
    method: 'get',
    url: 'Volunteer/parentsClassroom',
    params: data
  })
}
// 精细服务 Volunteer/fineService
export function fineService(data){
  return request({
    method: 'get',
    url: 'Volunteer/fineService',
    params: data
  })
}
// 视频列表 Video/getList
export function VideoGetList(data){
  return request({
    method: 'get',
    url: 'Video/getList',
    params: data
  })
}
// 视频详情 Video/videoDetails
export function videoDetails(data){
  return request({
    method: 'get',
    url: 'Video/videoDetails',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/Overview.js